import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Goutte = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.62 82.27">
  <G fill={color}>
    <Path d="M31.7,1.2c-.56-.76-1.45-1.2-2.39-1.2s-1.83.45-2.39,1.2C24.17,4.91,0,37.87,0,52.96c0,16.16,13.15,29.31,29.31,29.31s29.31-13.15,29.31-29.31c0-15.09-24.17-48.05-26.92-51.76ZM29.28,72.08c-10.53,0-19.1-8.57-19.1-19.1,0-1.64,1.33-2.98,2.98-2.98s2.98,1.33,2.98,2.98c0,7.25,5.9,13.15,13.15,13.15,1.64,0,2.98,1.33,2.98,2.98s-1.33,2.98-2.98,2.98Z"/>
  </G>
</Svg>
);
};

export default Goutte;
